import type { FC } from 'react';
import React from 'react';

import {
    INITIAL,
    SUCCESS,
    ERROR,
    SMS,
    PENDING,
    STEP_BY_STEP,
    SUCCESS_WITH_REDIRECT,
} from './config';
import type { TAlfaleasingLeasingFormV5 } from './models';

export const AlfaleasingLeasingFormV5: FC<TAlfaleasingLeasingFormV5> = ({
    Case,
    ErrorSendLayout,
    Form,
    FormLayout,
    SmsLayout,
    StepByStepLayout,
    SuccessSendLayout,
    SuccessWithRedirectLayout,
    analytics,
    formId,
    fullWidth,
    linkToCheckInn,
    locationPlaceholder,
    redirectPathTemplate,
    safeguardText,
    textTermsUse,
    fields = ['inn', 'location', 'fio', 'phone', 'email'],
}) => {
    return (
        <Form
            analytics={analytics}
            fields={fields}
            formId={formId}
            fullWidth={fullWidth}
            redirectPathTemplate={redirectPathTemplate}
            safeguardText={safeguardText}
        >
            <Case type={[INITIAL, PENDING]}>
                <FormLayout
                    linkToCheckInn={linkToCheckInn}
                    locationPlaceholder={locationPlaceholder}
                    safeguardText={safeguardText}
                    textTermsUse={textTermsUse}
                />
            </Case>
            <Case type={STEP_BY_STEP}>
                <StepByStepLayout />
            </Case>
            <Case type={SMS}>
                <SmsLayout />
            </Case>
            <Case type={SUCCESS}>
                <SuccessSendLayout />
            </Case>
            <Case type={ERROR}>
                <ErrorSendLayout />
            </Case>
            <Case type={SUCCESS_WITH_REDIRECT}>
                <SuccessWithRedirectLayout />
            </Case>
        </Form>
    );
};
